import { formatFilterDate } from '@/utils/interview-day-format';
import { apiQuery } from '../';

export const interviewApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getInterviewList: builder.query({
        transformResponse: (response) => ({
          interviewList: response.data,
          meta: response.meta,
        }),
        query: ({ page, searchInput, sort, filter }) => {
          const qParams = { page: page, sort_by: {}, filter_by: {} };
          const { status, date_range } = filter || {};
          if (status?.values) {
            qParams['filter_by']['intelligence_status'] = status.values;
          }
          if (date_range) {
            const { from, to } = date_range;
            if (from) {
              const fromDate = new Date(from.setHours(0, 0, 0, 0));
              qParams['filter_by']['starts_after'] = formatFilterDate(fromDate);
            }
            if (to) {
              const toDate = new Date(to.setHours(23, 59, 59, 999));
              qParams['filter_by']['ends_before'] = formatFilterDate(toDate);
            }
          }
          if (searchInput) {
            qParams['filter_by']['name'] = searchInput;
          }
          if (sort) {
            qParams['sort_by'][Object.keys(sort)[0]] = Object.values(sort)[0];
          }

          return {
            method: 'get',
            url: `/interviews`,
            params: qParams,
          };
        },
      }),
      getInterview: builder.query({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { interviewId } = payload;
          return {
            method: 'get',
            url: `/interviews/${interviewId}`,
          };
        },
      }),
      getInterviewTranscript: builder.query({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { interviewId } = payload;
          return {
            method: 'get',
            url: `/interviews/${interviewId}/transcript`,
          };
        },
      }),
      getSummary: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { interviewId } = payload;
          return {
            method: 'get',
            url: `/interviews/${interviewId}/summary`,
          };
        },
      }),
      getAINotes: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { interviewId } = payload;
          return {
            method: 'get',
            url: `/interviews/${interviewId}/ai_notes`,
          };
        },
      }),
      postConversation: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { interviewId, ...rest } = payload;
          return {
            method: 'post',
            url: `/interviews/${interviewId}/conversations`,
            data: rest,
          };
        },
      }),
      getConversation: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { interviewId, ...rest } = payload;
          return {
            method: 'post',
            url: `/interviews/${interviewId}/conversation_status`,
            data: rest,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useLazyGetInterviewListQuery,
  useGetInterviewListQuery,
  useGetInterviewQuery,
  useGetInterviewTranscriptQuery,
  useGetSummaryMutation,
  useGetAINotesMutation,
  usePostConversationMutation,
  useGetConversationMutation,
} = interviewApi;
